import Notifications_items from './notifications_items.js';
import Notifications_bread from './Notifications_breadcrumbs';
import edit from './Notifications_edit';

export default {
  namespaced: true,
  modules   : {
    Notifications_items,
    Notifications_bread,
    edit,
  },
}
;
